import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export const useDeleteIngredientCategory = (
    invalidQueryKeys: string | (string | number)[],
): UseMutationResult<void, unknown, { categoryId: string }> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<void, unknown, { categoryId: string }>({
        mutationFn: async (parameters: { categoryId: string }) => {
            if (!auth.token) {
                throw new Error("Cannot save without authorization token.");
            }
            return await api.Ingredients.deleteCategory(parameters.categoryId, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
